import { PITEventService } from "@pit/core";
import { IDtoDepot, IDtoUser } from "@pit/frontend-model";
import { BehaviorSubject } from "rxjs";
import { PinItTrackFrontendDataServicesAccessor } from "../../../module.data/accessor/implementations/pin.it.track.frontend.data.services.accessor";
import { PinItTrackFrontendEntityStoreFacadesAccessor } from "../../../module.store/accessor/pin.it.track.frontend.entity.store.facades.accessor";
import { PinItTrackFrontendCoreServicesAccessor } from "../implementations/pin.it.track.frontend.core.services.accessor";

export interface IPinItTrackFrontendServicesAccessor {

    currentUser: IDtoUser;
    currentUser$: BehaviorSubject<IDtoUser>;
    selectedDepot: IDtoDepot;
    selectedDepot$: BehaviorSubject<IDtoDepot>;

    coreServicesAccessor?: PinItTrackFrontendCoreServicesAccessor;
    dataServicesAccessor?: PinItTrackFrontendDataServicesAccessor;
    entityStoreFacadesAccessor?: PinItTrackFrontendEntityStoreFacadesAccessor;
    eventService?: PITEventService;

}
